import { Component, Input, OnInit } from '@angular/core';
import { DashboardDataService } from '@widgets/services/dashboard-data.service';
import { WidgetComponent } from '@widgets/widgets';
import { StudentComment } from '@widgets/models/StudentComment';

@Component({
  selector: 'lms-student-comment',
  templateUrl: './student-comment.component.html',
  styleUrls: ['./student-comment.component.scss']
})
export class StudentCommentComponent implements WidgetComponent, OnInit {
  @Input() public data: any;
  public commentList: StudentComment[] = [];
  public activeIndex: number = 0;
  public disabledArrows: boolean = false;

  constructor(public dashboardService: DashboardDataService) {}

  public ngOnInit(): void {
    this.commentList = this.data['studentComments'];
    this.disabledArrows = this.commentList.length <= 1;
  }

  public trackByComment(index: number, comment: any): string {
    return comment ? comment._id : null;
  }

  /**
   * Move the carousel at the previous index
   */
  public previous(): void {
    if (!this.disabledArrows) {
      if (this.activeIndex === 0) {
        // this.activeIndex = this.commentList.length - 1;
      } else {
        this.activeIndex--;
      }
    }
  }

  /**
   * Move the carousel at the next index
   */
  public next(): void {
    if (!this.disabledArrows) {
      if (this.activeIndex === this.commentList.length - 1) {
        // this.activeIndex = 0;
      } else {
        this.activeIndex++;
      }
    }
  }
}
